export const suggestOption = (
  value: string | Record<string, string | number>,
  options = { text: '' }
) => {
  if (value && typeof value === 'string') {
    return options.text;
  }
};
